// extracted by mini-css-extract-plugin
export default {"informationRow":"WeatherToday_informationRow__Lxy+I","wind":"WeatherToday_wind__nZ687","proLayout":"WeatherToday_proLayout__etLF+"};